import React, { useEffect, useMemo, useRef } from 'react';
import Hls from 'hls.js';

const HlsVideoPlayer = ({
  src,
  style,
  onPlay,
  onPause,
  onEnded,
  className,
}) => {
  const videoRef = useRef(null);
  const isHls = useMemo(
    () => typeof src === 'string' && src.includes('.m3u8'),
    [src]
  );
  const poster = useMemo(() => {
    if (!isHls) return null;
    const videoId = src.split('/')[3];
    if (videoId) {
      return `https://customer-quvpuvq5vklyms5a.cloudflarestream.com/${videoId}/thumbnails/thumbnail.jpg`;
    }
    return null;
  }, [src, isHls]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !isHls) return;

    let hls;

    if (Hls.isSupported()) {
      hls = new Hls({ lowLatencyMode: true });
      hls.loadSource(src);
      hls.attachMedia(video);
      hls.on(Hls.Events.ERROR, (_, data) => {
        console.error('HLS.js error:', data);
      });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [src, isHls]);

  return (
    <video
      ref={videoRef}
      controls
      playsInline
      webkit-playsinline="true"
      preload="metadata"
      poster={poster}
      controlsList="nodownload"
      src={!isHls ? src : undefined}
      onPlay={onPlay}
      onPause={onPause}
      onEnded={onEnded}
      className={className}
      style={{ width: '100%', borderRadius: '8px', ...style }}
    >
      {!isHls && src && <source src={src} type="video/mp4" />}
    </video>
  );
};

export default HlsVideoPlayer;
